import React from "react";
import {observer} from "mobx-react";
import {VideoSlidesFilterItemPreviewComponent} from "./item/video-slides-filter-item-preview.component"
import {ExploreButtonBox} from "../../orbit-swiper/orbit-swiper-buttons/boxes/button/explore-button.box";
import styled, {css} from "styled-components";
import {useServices} from "../../../react-hooks/use-services.hook";
import {VideoSlidesFilterListPreviewBox} from "./list/container/video-slides-filter-list-preview.box";
import {VideoSlidesFilterListPreviewHeaderBox} from "./list/header/video-slides-filter-list-preview-header.box";
import {VideoSlidesFilterListPreviewTitleBox} from "./list/title/video-slides-filter-list-preview-title.box";
import {VideoSlidesFilterListPreviewContentBox} from "./list/content/video-slides-filter-list-preview-content.box";
import {CyClass} from "../../../../common/cy-classes";

export const SwiperButtonBox = styled.div<{isTouchDevice?: boolean}>`
    ${({isTouchDevice}) => isTouchDevice ? css`
        display: none;
    ` : null}
`;


interface VideoSlidesFilterPreviewProps {
    hasHeaderButton: boolean;
    height: string;
    filterIdList: string[];
}
export const VideoSlidesFilterListPreviewComponent: React.FC<VideoSlidesFilterPreviewProps> = observer((props) => {
    const services = useServices();
    let ExploreOutlinedIcon = services.theme.currentTheme.icons.exploreOutlinedIcon;
    const btnOnClick = () => {
        services.analytics.sendOrbitUserFlowEvent('navigation', 'videoSlidesOpenSeeAllBtn');
        services.linksNavigation.navigateLink({linkId: 'videoSlideExploreLink'});
    }
    return (
        <VideoSlidesFilterListPreviewBox className={CyClass('cy-video-slides-filters-preview')}>
            <VideoSlidesFilterListPreviewHeaderBox>
                <ExploreOutlinedIcon size={2.2} style={{marginRight: "10px", color: services.theme.currentTheme.colors.brandPrimary}} />
                <VideoSlidesFilterListPreviewTitleBox>
                    {services.translation.translate("VIDEO_SLIDES_FILTER_PREVIEW_TITLE")}
                </VideoSlidesFilterListPreviewTitleBox>
                <SwiperButtonBox>
                    <ExploreButtonBox
                        className={CyClass('cy-video-slides-filters-explore-button')}
                        preset="flatStroked"
                        sizeVariant="xs"
                        noRemUnits
                        onClick={btnOnClick}>
                        {services.translation.translate("EXPLORE")}
                    </ExploreButtonBox>
                </SwiperButtonBox>
            </VideoSlidesFilterListPreviewHeaderBox>
            <VideoSlidesFilterListPreviewContentBox>
                {props.filterIdList.map(filterId => (
                    <VideoSlidesFilterItemPreviewComponent
                        key={"VideoSlidesFilter" + filterId}
                        filterId={filterId}
                        filterCount={props.filterIdList.length} />)
                )}
            </VideoSlidesFilterListPreviewContentBox>
        </VideoSlidesFilterListPreviewBox>
    )
});
